import { render, staticRenderFns } from "./CramStudentTable.vue?vue&type=template&id=070b89d6&"
import script from "./CramStudentTable.vue?vue&type=script&lang=ts&"
export * from "./CramStudentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports